const testId = {
  container: 'NotesModal.container',
  submit: 'NotesModal.submit',
  cancel: 'NotesModal.cancel',
  textarea: 'NotesModal.textarea',
};

export default testId;
